import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Radio, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import item from '~pages/onboarding/property-type/item';

const useStyles = makeStyles(
  theme => ({
    filter: {
      ...theme.flex.mainStart,
      marginRight: '16px',
      flexShrink: 0,

      '& > *:not(:first-child)': { marginLeft: 8 },
      '& .ant-radio-group': { display: 'flex' },
    },
    radioBtn: {
      ...theme.flex.mainCenter,
      alignItems: 'center',
    },
    radioBtnCount: {
      height: 16,
      minWidth: 16,
      marginLeft: 4,
      textAlign: 'center',
      fontSize: '10px',
      lineHeight: '16px',
      padding: '0 4px',
      color: theme.colors.gray1,
      borderRadius: theme.borderRadius.full,
      backgroundColor: theme.colors.red11,
    },
  }),
  { name: 'ReconciliationStageAndPropertyNameFilters' },
);

const ReconciliationBookingStatusFilters = ({
  bookingStatusList,
  bookingStatus,
  setBookingStatus,
}) => {
  const classes = useStyles();

  const handleClickRadioGroup = e => {
    setBookingStatus(e?.target?.value);
  };

  return (
    <div className={classes.filter}>
      <Radio.Group value={bookingStatus} onChange={handleClickRadioGroup}>
        <For of={bookingStatusList} each="item">
          <Choose>
            <When condition={item?.popoverContent}>
              <Tooltip title={item?.popoverContent} placement="topLeft">
                <Radio.Button value={item?.value} key={item?.value}>
                  <div className={classes.radioBtn}>
                    <If condition={item?.pointClassName}>
                      <span className={item?.pointClassName} />
                    </If>
                    <span>{item.label}</span>
                    <If condition={item?.count}>
                      <div className={classes.radioBtnCount}>
                        {item?.count > 99 ? '99+' : item?.count}
                      </div>
                    </If>
                  </div>
                </Radio.Button>
              </Tooltip>
            </When>
            <When condition={!item?.popoverContent}>
              <Radio.Button value={item?.value} key={item?.value}>
                <div className={classes.radioBtn}>
                  <If condition={item?.pointClassName}>
                    <span className={item?.pointClassName} />
                  </If>
                  <span>{item.label}</span>
                  <If condition={item?.count}>
                    <div className={classes.radioBtnCount}>
                      {item?.count > 99 ? '99+' : item?.count}
                    </div>
                  </If>
                </div>
              </Radio.Button>
            </When>
          </Choose>
        </For>
      </Radio.Group>
    </div>
  );
};

ReconciliationBookingStatusFilters.propTypes = {
  bookingStatus: PropTypes.string,
  setBookingStatus: PropTypes.func,
  bookingStatusList: PropTypes.array,
};

export default ReconciliationBookingStatusFilters;
